import { createBrowserRouter, Navigate } from 'react-router';

import { AuthGuard, RoleGuard } from '../features/auth/guards';
import { ForgotPasswordPage } from '../features/auth/ForgotPasswordPage';
import { LoginPage } from '../features/auth/LoginPage';
import { ResetPasswordPage } from '../features/auth/ResetPasswordPage';
import { AdminUserCreatePage } from '../features/admin/AdminUserCreatePage';
import { ClinicsPage } from '../features/admin/ClinicsPage';
import { DashboardPage } from '../features/admin/DashboardPage';
import { DoctorDetailPage } from '../features/admin/DoctorDetailPage';
import { DoctorsPage } from '../features/admin/DoctorsPage';
import { PartnershipRequestsPage } from '../features/admin/PartnershipRequestsPage';
import { ExaminationDetailPage } from '../features/examinations/ExaminationDetailPage';
import { PatientDetailPage } from '../features/patients/PatientDetailPage';
import { PatientFormPage } from '../features/patients/PatientFormPage';
import { PatientsListPage } from '../features/patients/PatientsListPage';
import { ProfilePage } from '../features/profile/ProfilePage';
import { PartnershipPage } from '../features/partnership/PartnershipPage';
import { PublicSharePage } from '../features/share/PublicSharePage';
import { DownloadsPage } from '../features/software/DownloadsPage';
import { SoftwarePage } from '../features/software/SoftwarePage';
import { AppLayout } from './AppLayout';
import { RouteError } from './RouteError';

// Онлайн-просмотр снимков вынесен в отдельный сервис (services/viewer),
// gateway отдаёт его по /viewer/*. Переход туда — обычной ссылкой (см.
// ExaminationDetailPage), поэтому маршрутов snapshots/compare здесь больше нет.

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  // Ссылка из письма для получателя без аккаунта — только скачивание архива.
  { path: '/s/:token', element: <PublicSharePage /> },
  // Программа для просмотра снимков (Romexis) — публично, ссылки есть в письмах.
  { path: '/downloads', element: <DownloadsPage /> },
  // Заявка «Сотрудничество» — кнопка в письме со снимками, публично.
  { path: '/partnership', element: <PartnershipPage /> },
  {
    path: '/',
    element: (
      <AuthGuard>
        <AppLayout />
      </AuthGuard>
    ),
    errorElement: <RouteError />,
    children: [
      { index: true, element: <Navigate to="/patients" replace /> },
      { path: 'patients', element: <PatientsListPage /> },
      {
        path: 'patients/new',
        element: (
          <RoleGuard allow={['admin']}>
            <PatientFormPage />
          </RoleGuard>
        ),
      },
      { path: 'patients/:id', element: <PatientDetailPage /> },
      {
        path: 'patients/:id/edit',
        element: (
          <RoleGuard allow={['admin']}>
            <PatientFormPage />
          </RoleGuard>
        ),
      },
      { path: 'examinations/:id', element: <ExaminationDetailPage /> },
      { path: 'profile', element: <ProfilePage /> },
      { path: 'software', element: <SoftwarePage /> },
      {
        path: 'admin/doctors',
        element: (
          <RoleGuard allow={['admin']}>
            <DoctorsPage />
          </RoleGuard>
        ),
      },
      {
        path: 'admin/users/new',
        element: (
          <RoleGuard allow={['admin']}>
            <AdminUserCreatePage />
          </RoleGuard>
        ),
      },
      {
        path: 'admin/doctors/:id',
        element: (
          <RoleGuard allow={['admin']}>
            <DoctorDetailPage />
          </RoleGuard>
        ),
      },
      {
        path: 'admin/clinics',
        element: (
          <RoleGuard allow={['admin']}>
            <ClinicsPage />
          </RoleGuard>
        ),
      },
      {
        path: 'admin/dashboard',
        element: (
          <RoleGuard allow={['admin']}>
            <DashboardPage />
          </RoleGuard>
        ),
      },
      {
        path: 'admin/partnership',
        element: (
          <RoleGuard allow={['admin']}>
            <PartnershipRequestsPage />
          </RoleGuard>
        ),
      },
    ],
  },
]);
